export const data = [
  {
    id: 0,
    date: "2020-07-26",
    number: "8",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
  {
    id: 1,
    date: "2020-07-25",
    number: "7",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
  {
    id: 2,
    date: "2020-07-25",
    number: "6",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
  {
    id: 3,
    date: "2020-07-23",
    number: "5",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
  {
    id: 4,
    date: "2020-07-22",
    number: "4",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
  {
    id: 5,
    date: "2020-07-21",
    number: "3",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
  {
    id: 6,
    date: "2020-07-13",
    number: "2",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
  {
    id: 7,
    date: "2020-07-11",
    number: "1",
    content: "CU 편의점 상온 배송 차량",
    kind: "1톤",
  },
];

export const data2 = [
  {
    id: 0,
    date: "2020-07-26",
    number: "8",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
  {
    id: 1,
    date: "2020-07-23",
    number: "7",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
  {
    id: 2,
    date: "2020-07-21",
    number: "6",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
  {
    id: 3,
    date: "2020-07-21",
    number: "5",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
  {
    id: 4,
    date: "2020-07-16",
    number: "4",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
  {
    id: 5,
    date: "2020-07-14",
    number: "3",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
  {
    id: 6,
    date: "2020-07-22",
    number: "2",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
  {
    id: 7,
    date: "2020-07-22",
    number: "1",
    content: "CU 편의점 상온 배송 차량",
    kind: "2.5톤",
  },
];

export const data3 = [{}];

export const vehicleType = {
  "001": "1톤",
  "002": "2.5톤",
  "003": "4.5톤",
  "004": "5톤",
}